import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export const constantRouterMap = [
  {
    path: "/",
    name: "login",
    component: () => import("@/views/login/index"),
    hidden: true,
  },
  {
    path: "/404",
    component: () => import("@/components/404"),
    hidden: true,
  },
  {
    path: "/index",
    component: () => import("@/components/tabbar2"),
    redirect: "/index",
    children: [
      {
        path: "/index",
        component: () => import("@/views/home"),
      },
    ],
  },
  {
    path: "/order",
    component: () => import("@/components/tabbar2"),
    hidden: true,
    redirect: "/order/orderProcessing",
    children: [
      {
        meta: { title: "订单处理", icon: "home" },
        name: "orderProcessing",
        path: "orderProcessing",
        component: () => import("@/views/order/orderProcessing"),
      },
      {
        meta: { title: "订单查询", icon: "home" },
        name: "orderInquiry",
        path: "orderInquiry",
        component: () => import("@/views/order/orderInquiry"),
      },
      {
        meta: { title: "订单预警", icon: "home" },
        name: "orderWarning",
        path: "orderWarning",
        component: () => import("@/views/order/orderWarning"),
      },
      {
        meta: { title: "订单拣货", icon: "home" },
        name: "orderPicking",
        path: "orderPicking",
        component: () => import("@/views/order/orderPicking"),
      },
      {
        meta: { title: "拣货结算", icon: "home" },
        name: "orderPickingSettle",
        path: "orderPickingSettle",
        component: () => import("@/views/order/orderPickingSettle"),
      },
      {
        meta: { title: "校正记录", icon: "home" },
        name: "orderSheet",
        path: "orderSheet",
        component: () => import("@/views/order/orderSheet"),
      }
    ],
  },
  {
    path: "/shop",
    component: () => import("@/components/tabbar2"),
    hidden: true,
    redirect: "/shop/shopList",
    children: [
      {
        meta: { title: "店铺信息" },
        path: "shopList",
        component: () => import("@/views/shop/shopList"),
      },
      {
        meta: { title: "店铺管理" },
        path: "shopManage",
        component: () => import("@/views/shop/shopManage"),
      },
      {
        meta: { title: "商品管理" },
        path: "shopGoods",
        component: () => import("@/views/shop/shopGoods"),
      }
    ],
  },
  {
    path: "/store",
    component: () => import("@/components/tabbar2"),
    hidden: true,
    redirect: "/store/storeDevice",
    children: [
      {
        meta: { title: "门店智控" },
        path: "storeDevice",
        component: () => import("@/views/store/storeDevice"),
      }
    ],
  },
  {
    path: "/components/videoWindows",
    hidden: true,
    component: () => import("@/components/ImouVideo/videoWindows"),
  },
  {
    path: "/data",
    component: () => import("@/components/tabbar2"),
    hidden: true,
    redirect: "/data/tradeOverview",
    children: [
      {
        meta: { title: "营业概括" },
        path: "tradeOverview",
        component: () => import("@/views/data/businessData"),
      },
      {
        meta: { title: "门店统计" },
        path: "storeCount",
        component: () => import("@/views/data/shopData"),
      },
      {
        meta: { title: "配送分析" },
        path: "deliveryAnalysis",
        component: () => import("@/views/data/deliveryData"),
      },
      {
        meta: { title: "渠道分析" },
        path: "channelAnalysis",
        component: () => import("@/views/data/trenchData"),
      },
      {
        meta: { title: "商品分析" },
        path: "goodsAnalysis",
        component: () => import("@/views/data/goodsAnalyze"),
      }
    ],
  },
  {
    path: "/settings",
    component: () => import("@/components/tabbar2"),
    hidden: true,
    redirect: "/settings/merchantSetting",
    children: [
      {
        meta: { title: "商户管理" },
        path: "merchantSetting",
        component: () => import("@/views/settings/merchant"),
      },
      {
        meta: { title: "账号管理" },
        path: "userIndex",
        component: () => import("@/views/settings/userIndex"),
      },
      {
        meta: { title: "通知设置" },
        path: "notificationsSettings",
        component: () => import("@/views/settings/notificationsSettings"),
      },
      {
        meta: { title: "配送设置" },
        path: "deliverySettings",
        component: () => import("@/views/settings/deliverySetting"),
      },
      {
        meta: { title: "操作日志" },
        path: "log",
        component: () => import("@/views/settings/log"),
      },
    ],
  },
  // {
  //   name: "call",
  //   path: "/call",
  //   component: () => import("@/components/tabbar2"),
  //   hidden: true,
  //   redirect: "/call/callDataCountUser",
  //   children: [
  //     {
  //       meta: { title: "坐席绑定", icon: "home" },
  //       name: "callBind",
  //       path: "callBind",
  //       component: () => import("@/views/call/callBind"),
  //     },
  //     {
  //       meta: { title: "呼叫设置", icon: "home" },
  //       name: "callSetting",
  //       path: "callSetting",
  //       component: () => import("@/views/call/callSetting"),
  //     },
  //     {
  //       meta: { title: "呼叫日志", icon: "home" },
  //       name: "callBindLog",
  //       path: "callBindLog",
  //       component: () => import("@/views/call/callBingLog.vue"),
  //     },
  //     {
  //       meta: { title: "坐席监控", icon: "home" },
  //       name: "callMonitor",
  //       path: "callMonitor",
  //       component: () => import("@/views/call/callMonitor"),
  //     },
  //     {
  //       meta: { title: "状态时长统计报表", icon: "home" },
  //       name: "statusReport",
  //       path: "statusReport",
  //       component: () => import("@/views/call/statusReport"),
  //     },
  //     {
  //       meta: { title: "状态时长详情", icon: "home" },
  //       name: "statusReportDetail",
  //       path: "statusReportDetail",
  //       component: () => import("@/views/call/statusReportDetail"),
  //     },
  //     {
  //       meta: { title: "通话记录", icon: "home" },
  //       name: "callRecord",
  //       path: "callRecord",
  //       component: () => import("@/views/call/callRecord"),
  //     },
  //     {
  //       meta: { title: "话务量报表统计", icon: "home" },
  //       name: "callRecordCount",
  //       path: "callRecordCount",
  //       component: () => import("@/views/call/callRecordCount"),
  //     },
  //     {
  //       meta: { title: "呼入日话务高峰", icon: "home" },
  //       name: "callInPeakByDay",
  //       path: "callInPeakByDay",
  //       component: () => import("@/views/call/callInPeakByDay"),
  //     },
  //     {
  //       meta: { title: "呼入月话务高峰", icon: "home" },
  //       name: "callInPeakByMonth",
  //       path: "callInPeakByMonth",
  //       component: () => import("@/views/call/callInPeakByMonth"),
  //     },
  //     {
  //       meta: { title: "电话接通日志", icon: "home" },
  //       name: "callAnswerLog",
  //       path: "callAnswerLog",
  //       component: () => import("@/views/call/callAnswerLog"),
  //     },
  //     {
  //       meta: { title: "电话响铃日志", icon: "home" },
  //       name: "callRingLog",
  //       path: "callRingLog",
  //       component: () => import("@/views/call/callRingLog"),
  //     },
  //     {
  //       meta: { title: "电话结束日志", icon: "home" },
  //       name: "callEndLog",
  //       path: "callEndLog",
  //       component: () => import("@/views/call/callEndLog"),
  //     },
  //     {
  //       meta: { title: "数据概览", icon: "home" },
  //       name: "callDataCount",
  //       path: "callDataCount",
  //       component: () => import("@/views/call/callDataCount"),
  //     },
  //     {
  //       meta: { title: "个人数据概览", icon: "home" },
  //       name: "callDataCountUser",
  //       path: "callDataCountUser",
  //       component: () => import("@/views/call/callDataCountUser"),
  //     },
  //     {
  //       meta: { title: "历史数据统计", icon: "home" },
  //       name: "callHistory",
  //       path: "callHistory",
  //       component: () => import("@/views/call/callHistory"),
  //     },
  //     {
  //       meta: { title: "话务排班", icon: "home" },
  //       name: "callSchedule",
  //       path: "callSchedule",
  //       component: () => import("@/views/call/callSchedule"),
  //     },
  //   ],
  // },
  {
    path: "/delivery",
    component: () => import("@/components/tabbar2"),
    hidden: true,
    redirect: "/delivery/deliveryInfo",
    children: [
      {
        meta: { title: "骑手信息管理"},
        path: "deliveryInfo",
        name: "deliveryInfo",
        component: () => import("@/views/delivery/deliveryInfo"),
      },
      {
        meta: { title: "运单管理"},
        name: "deliveryOrder",
        path: "deliveryOrder",
        component: () => import("@/views/delivery/deliveryOrder"),
      },
      {
        meta: { title: "自取货运单管理" },
        path: "deliverySelfTake",
        // path: "deliverySelfPickupGoodsOrder",
        component: () => import("@/views/delivery/deliverySelfPickupGoodsOrder"),
      },
      {
        meta: { title: "自配送运单管理" },
        path: "deliverySelf",
        // path: "deliverySelfDeliveryOrder",
        component: () => import("@/views/delivery/deliverySelfDeliveryOrder"),
      },
      {
        meta: { title: "历史运单" },
        path: "deliveryHistory",
        // path: "deliveryHistoryOrder",
        component: () => import("@/views/delivery/deliveryHistoryOrder"),
      },
      {
        meta: { title: "骑手运效分析" },
        path: "deliveryEffiRide",
        name: "deliveryEffiRide",
        // path: "deliveryEffiRider",
        component: () => import("@/views/delivery/deliveryEffiRider"),
      },
      {
        meta: { title: "骑手运单明细" },
        path: "riderOrderDetail",
        name: "riderOrderDetail",
        component: () => import("@/views/components/DeliveryEffiRider/riderOrderDetail"),
      },
      {
        meta: { title: "自取货骑手运单明细" },
        path: "selfPickupGoodsRiderOrderDetail",
        component: () => import("@/views/delivery/selfPickupGoodsRiderOrderDetail"),
      },
      {
        meta: { title: "渠道运效分析" },
        path: "deliveryEffiChannel",
        // path: "deliveryEffiChannel",
        component: () => import("@/views/delivery/deliveryEffiChannel"),
      },
      {
        meta: { title: "渠道运单管理" },
        path: "channelOrderDetail",
        component: () => import("@/views/delivery/channelOrderDetail"),
      },
      {
        meta: { title: "门店运效分析" },
        path: "deliveryEffiStore",
        // path: "deliveryEffiStore",
        component: () => import("@/views/delivery/deliveryEffiStore"),
      },
      {
        meta: { title: "门店运单管理" },
        path: "storeOrderDetail",
        component: () => import("@/views/delivery/storeOrderDetail"),
      },
      {
        meta: { title: "配送平台管理" },
        path: "deliveryPlatform",
        component: () => import("@/views/delivery/deliveryPlatform"),
      }
    ],
  },
  { path: "*", redirect: "/404", hidden: true },
  // {
  //   path: "/importData",
  //   component: () => import("@/views/importData"),
  // },
];

// export const asyncRouterMap = [
//   {
//     path: "/goods",
//     component: () => import("@/components/tabbar"),
//     hidden: true,
//     children: [
//       {
//         path: "/goods/goods",
//         component: () => import("@/views/goods/goods")
//       }
//     ]
//   },
//   { path: "*", redirect: "/404", hidden: true }
// ];

export default new Router({
  mode: "history", //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
});

// export default new Router({
//   // mode: 'history',
//   // mode:'hash',
//   routes: [
//     {
//       path: "/",
//       name: "login",
//       component: () => import("@/views/login/index"),
//       hidden: true
//     },
//     {
//       path: "/404",
//       component: () => import("@/components/404"),
//       hidden: true
//     },
//     {
//       path: "/index",
//       component: () => import("@/components/tabbar"),
//       redirect: "/index",
//       children: [
//         {
//           path: "/index",
//           component: () => import("@/views/home")
//         }
//       ]
//     },
//     {
//       path: "/system",
//       component: () => import("@/components/tabbar"),
//       hidden: true,
//       children: [
//         {
//           path: "/system/nav",
//           component: () => import("@/views/system/nav")
//         },
//         {
//           path: "/system/dept",
//           component: () => import("@/views/system/dept")
//         },
//         {
//           path: "/system/permission",
//           component: () => import("@/views/system/permission")
//         },
//         {
//           path: "/system/user",
//           component: () => import("@/views/system/user")
//         },
//         {
//           path: "/system/role",
//           component: () => import("@/views/system/role")
//         },
//         {
//           path: "/system/logs",
//           component: () => import("@/views/system/logs")
//         },
//         {
//           path: "/system/parameter",
//           component: () => import("@/views/system/parameter")
//         },
//         {
//           path: "/system/region",
//           component: () => import("@/views/system/region")
//         }
//       ]
//     },
//     {
//       path: "/goods",
//       component: () => import("@/components/tabbar"),
//       hidden: true,
//       children: [
//         {
//           path: "/goods/goods",
//           component: () => import("@/views/goods/goods")
//         }
//       ]
//     },
//     { path: "*", redirect: "/404", hidden: true }
//   ]
// });
